<template>
  <div class="iconWrapper" :style="{ backgroundColor: iconColor }">
    <i class="icon bi" :class="icon" />
  </div>
  <div class="title">
    <slot name="title" />
  </div>
  <div class="text">
    <slot name="text" />
    <div class="subtext">
      <slot name="subtext" />
    </div>
  </div>
  <div class="tips">
    <div class="top">
      <slot name="tipsTop" />
    </div>
    <ul class="list">
      <slot name="tipsList" />
    </ul>
    <div class="bottom">
      <slot name="tipsBottom" />
    </div>
  </div>
  <div class="buttons">
    <Button :label="$t('game.preGameModalChecksWithTips.backButton')" class="btn secondary outline" @click="$emit('back')" v-if="props.buttonBack" />
    <Button :label="$t('game.preGameModalChecksWithTips.restartButton')" class="btn primary" @click="$emit('restart')" v-if="props.buttonRestart" />
    <Button :label="$t('game.preGameModalChecksWithTips.nextButton')" class="btn secondary outline" @click="$emit('next')" v-if="props.buttonNext" />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.iconWrapper {
  width: 64px;
  height: 64px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-size: 48px;

  background-color: #1fa969;

  margin-top: 24px;
}

.title {
  font-size: 32px;
  font-weight: 700;

  @media screen and (max-width: $small-screen) {
    font-size: 20px;
  }
}

.text {
  font-size: 18px;

  margin: 24px 0;
  align-self: start;

  @media screen and (max-width: $small-screen) {
    font-size: 14px;
  }

  .subtext {
    color: #ffffffb3;
    font-size: 14px;

    @media screen and (max-width: $small-screen) {
      font-size: 12px;
    }
  }
}

.tips {
  align-self: stretch;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  padding: 24px;

  border-radius: 6px;
  border: 2px solid #464646;

  .top {
    color: #fff;
    text-align: justify;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media screen and (max-width: $small-screen) {
      font-size: 14px;
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;

    @media screen and (max-width: $small-screen) {
      font-size: 14px;
    }
  }

  .bottom {
    color: #ffffffb3;
    text-align: justify;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media screen and (max-width: $small-screen) {
      font-size: 12px;
    }
  }
}

:deep(b) {
  color: #f2cb36;
  font-weight: 700;
}

.buttons {
  display: flex;
  gap: 16px;

  margin-top: 24px;

  @media screen and (max-width: $small-screen) {
    font-size: 14px;
  }

  .btn {
    border: 2px solid #464646 !important;
  }
}
</style>

<script setup lang="ts">
const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  iconColor: {
    type: String,
    default: "#1FA969",
  },
  buttonBack: {
    type: Boolean,
    default: true,
  },
  buttonRestart: {
    type: Boolean,
    default: false,
  },
  buttonNext: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["back", "restart", "next"]);
</script>
